import { useEffect, useState } from "react";
import {
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import axiosInstance from "../../../services/axios-instance";
import {
    All_USERS_URL,
    HOLIDAYS_REQUESTS_URL,
    HOLIDAYS_URL,
} from "../../../services/endpoints";
import { AllUsersInterface } from "../../../interface/allUsersInterface";
import { AllHolidaysInterface } from "../../../interface/allHolidaysInterface";

interface AddingHolidaysFormParams {
    setAllHolidays: React.Dispatch<
        React.SetStateAction<AllHolidaysInterface[]>
    >;
}
const AddingHolidaysForm = ({ setAllHolidays }: AddingHolidaysFormParams) => {
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
    const [selectedUser, setSelectedUser] = useState("");

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(All_USERS_URL);
                setUsers(response.data.data);

                if (selectedUser) {
                    const responseHolidaysRequests = await axiosInstance.get(
                        HOLIDAYS_REQUESTS_URL(+selectedUser)
                    );

                    setAllHolidays(responseHolidaysRequests.data.data);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchUsers();
    }, [selectedUser]);

    const handleFetchAllHolidays = async (e: {
        preventDefault: () => void;
    }) => {
        e.preventDefault();
        try {
            const responseAllHolidays = await axiosInstance.get(HOLIDAYS_URL);
            setAllHolidays(responseAllHolidays.data.data);

            setSelectedUser("");
        } catch (error) {
            console.error(error);
            // Handle error if needed
        }
    };

    return (
        <form
            onSubmit={handleFetchAllHolidays}
            style={{
                marginBottom: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Button
                type="submit"
                variant="contained"
                color="info"
                sx={{
                    marginBottom: "12px",
                    height: "54px", // Set the desired height
                }}
            >
                All Holidays
            </Button>
            <FormControl
                sx={{
                    marginBottom: "12px",
                    marginLeft: "8px",
                }}
            >
                <InputLabel id="user-select-label">Select User</InputLabel>
                <Select
                    labelId="user-select-label"
                    label="Select User"
                    id="user-select"
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    style={{ minWidth: "200px" }}
                >
                    {users.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                            {user.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </form>
    );
};

export default AddingHolidaysForm;
